
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"180","height":"136","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"178","height":"134","rx":"13","fill":"#F4F6FA"}}),_c('path',{attrs:{"opacity":".4","fill":"#9AA5BB","fill-opacity":".5","d":"M72 74h78v6H72zM72 84h78v6H72zM72 94h78v6H72zM72 122h78v12H72zM72 104h41v6H72z"}}),_c('path',{attrs:{"opacity":".9","fill":"#9AA5BB","fill-opacity":".5","d":"M53 12h20v6H53zM107 12h20v6h-20zM77 12h26v6H77z"}}),_c('path',{attrs:{"opacity":".4","fill":"#9AA5BB","fill-opacity":".5","d":"M30 30h120v36H30zM66 74v20H30V74zM66 98v20H30V98zM66 122v12H30v-12z"}}),_c('path',{attrs:{"d":"M14 20l4.267-10H30l-4.267 10H14z","fill":"#9AA5BB","fill-opacity":".25"}}),_c('circle',{attrs:{"opacity":".6","cx":"162","cy":"117","r":"8","fill":"#F39"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M162 22a6 6 0 10-5.197-9H142v6h14.803A5.996 5.996 0 00162 22z","fill":"#9AA5BB","fill-opacity":".25"}}),_c('rect',{attrs:{"opacity":".6","x":"8","y":"89","width":"31","height":"12","rx":"6","transform":"rotate(-90 8 89)","fill":"#F39"}})])
          )
        }
      }
    